module.exports = __webpack_public_path__ + "img/pve.ae1f45b9.svg";